import React from "react";
import PropTypes from "prop-types";

import Select from "react-select";

import "./GridDropdown.scss";

const GridDropdown = (props) => {
  const defaultSelectedOption = props.value
    ? props.options?.find((option) => option.value === props.value)
    : null;

  const defaultSelectedOptionMultiSelect = Array.isArray(props.value)
    ? props.options.filter((option) => props.value.includes(option.value))
    : [];

  return (
    <div className="grid-dropdown">
      <span className="d-inline-block custom-input">
        <Select
          className={`${props.cssClass} ${props.hasError ? "error-border" : ""
            }`}
          // value={props.value}
          value={
            props.isMultiSelect
              ? defaultSelectedOptionMultiSelect
              : defaultSelectedOption
          } // Pass the selected value from the parent component
          onChange={props.onChange}
          options={props.options}
          isMulti={props.isMultiSelect}
          placeholder={props.placeholder}
          isDisabled={props.isDropdownDisabled}
          menuPortalTarget={document.body}
          menuPosition="absolute"
          menuPlacement="auto"
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
        />
        {props.hasError && <div className="error-icon">!</div>}
      </span>
    </div>
  );
};
GridDropdown.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.object,
    PropTypes.arrayOf(PropTypes.object),
  ]),
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  isMultiSelect: PropTypes.bool,
  placeholder: PropTypes.string,
  isDropdownDisabled: PropTypes.bool,
  cssClass: PropTypes.string,
  hasError: PropTypes.bool,
};

export default GridDropdown;
